import UltraRewardContent from "./UltraRewardContent";
export default UltraRewardContent;